/**
 * Parent folder select for nested group modals (text + sender)
 * For Media Devoted | Created By Ciro Autiero
 */

import { optionLabelForGroup } from '../../../utils/group-tree.utils';

import type { TreeNestedPromptGroup } from '../../../types/campaign-texts.types';

interface ParentFolderFieldsProps {
  parentId: string | null;
  onParentChange: (id: string | null) => void;
  parentOptions: TreeNestedPromptGroup[];
  treeForLabels: TreeNestedPromptGroup[];
}

export function ParentFolderFields({
  parentId,
  onParentChange,
  parentOptions,
  treeForLabels,
}: ParentFolderFieldsProps) {
  return (
    <div>
      <label className="text-xs font-medium text-muted-foreground">Parent folder</label>
      <select
        className="mt-1 h-9 w-full rounded-md border border-border bg-background px-2 text-sm"
        value={parentId ?? ''}
        onChange={(e) => onParentChange(e.target.value || null)}
      >
        <option value="">(Top level)</option>
        {parentOptions.map((g) => (
          <option key={g.id} value={g.id}>
            {optionLabelForGroup(g, treeForLabels)}
          </option>
        ))}
      </select>
    </div>
  );
}
